export enum VoivodeshipType {
    DOLNOSLASKIE = "dolnoslaskie",
    KUJAWSKOPOMORSKIE = "kujawsko-pomorskie",
    LODZKIE = "lodzkie",
    LUBELSKIE = "lubelskie",
    LUBUSKIE = "lubuskie",
    MALOPOLSKIE = "malopolskie",
    MAZOWIECKIE = "mazowieckie",
    OPOLSKIE = "opolskie",
    PODKARPACKIE = "podkarpackie",
    PODLASKIE = "podlaskie",
    POMORSKIE = "pomorskie",
    SLASKIE = "slaskie",
    SWIETOKRZYSKIE = "swietokrzyskie",
    WARMINSKOMAZURSKIE = "warminsko-mazurskie",
    WIELKOPOLSKIE = "wielkopolskie",
    ZACHODNIOPOMORSKIE = "zachodniopomorskie"
}

export const voivodeshipParser = (voivodeship: string) => {
    switch (voivodeship) {
        case "lodzkie":
            return "łódzkim";
        case "slaskie":
            return "śląskim";
        case "lubuskie":
            return "lubuskim";
        case "opolskie":
            return "opolskim";
        case "lubelskie":
            return "lubelskim";
        case "podlaskie":
            return "podlaskim";
        case "pomorskie":
            return "pomorskim";
        case "malopolskie":
            return "małopolskim";
        case "mazowieckie":
            return "mazowieckim";
        case "dolnoslaskie":
            return "dolnośląskim";
        case "podkarpackie":
            return "podkarpackim";
        case "wielkopolskie":
            return "wielkopolskim";
        case "swietokrzyskie":
            return "świętokrzyskim";
        case "kujawsko-pomorskie":
            return "kujawsko-Pomorskim";
        case "zachodniopomorskie":
            return "zachodniopomorskim";
        case "warminsko-mazurskie":
            return "warmińsko-Mazurskim";
        default:
            return "";
    }
};
export enum VoivodeshipType {
    DOLNOSLASKIE = "dolnoslaskie",
    KUJAWSKOPOMORSKIE = "kujawsko-pomorskie",
    LODZKIE = "lodzkie",
    LUBELSKIE = "lubelskie",
    LUBUSKIE = "lubuskie",
    MALOPOLSKIE = "malopolskie",
    MAZOWIECKIE = "mazowieckie",
    OPOLSKIE = "opolskie",
    PODKARPACKIE = "podkarpackie",
    PODLASKIE = "podlaskie",
    POMORSKIE = "pomorskie",
    SLASKIE = "slaskie",
    SWIETOKRZYSKIE = "swietokrzyskie",
    WARMINSKOMAZURSKIE = "warminsko-mazurskie",
    WIELKOPOLSKIE = "wielkopolskie",
    ZACHODNIOPOMORSKIE = "zachodniopomorskie"
}

export const voivodeshipParser = (voivodeship: string) => {
    switch (voivodeship) {
        case "lodzkie":
            return "łódzkim";
        case "slaskie":
            return "śląskim";
        case "lubuskie":
            return "lubuskim";
        case "opolskie":
            return "opolskim";
        case "lubelskie":
            return "lubelskim";
        case "podlaskie":
            return "podlaskim";
        case "pomorskie":
            return "pomorskim";
        case "malopolskie":
            return "małopolskim";
        case "mazowieckie":
            return "mazowieckim";
        case "dolnoslaskie":
            return "dolnośląskim";
        case "podkarpackie":
            return "podkarpackim";
        case "wielkopolskie":
            return "wielkopolskim";
        case "swietokrzyskie":
            return "świętokrzyskim";
        case "kujawsko-pomorskie":
            return "kujawsko-Pomorskim";
        case "zachodniopomorskie":
            return "zachodniopomorskim";
        case "warminsko-mazurskie":
            return "warmińsko-Mazurskim";
        default:
            return "";
    }
};
